/* eslint-disable react-hooks/exhaustive-deps */

import { Col, Container, Row, Table } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { AppDispatch } from "../../../.."
import TextInput from "../../../../components/InputWrapper/TextInput"
import {
  syaryoMasterActions,
  TSyaryoMasterState,
} from "../../../../globalStore/pageStore/syaryoMaster/syaryoMasterStore"
import { RootState } from "../../../../globalStore/rootreducer"
// import FileUploadModal from "./AttachedFileModal"
// immutable
//React/Redux

/**
 * 車輌マスタ登録 基本データ部
 * @returns
 */
const TireSizeDataPane = () => {
  //#region [selector]
  const syaryoMaster: TSyaryoMasterState = useSelector((state: RootState) => state.page.syaryoMaster)
  const disPatch: AppDispatch = useDispatch()

  //#endregion
  return (
    <>
      <div className="accordion-header">
        タイヤサイズ
        <div className="accordion-description">タイヤサイズ</div>
      </div>
      <div>
        <div>
          <h5>タイヤサイズ</h5>
          <Container className="register-form" fluid>
            <Row>
              <Col>
                <Table className="form-table">
                  <tbody>
                    <tr>
                      <th className="min-w-8rem">フロント</th>
                      <td>
                        <div className="input-group">
                          <TextInput
                            style={{ width: "20rem" }}
                            id="フロント"
                            name="フロント"
                            value={syaryoMaster.タイヤサイズフロント}
                            setValue={(v) => disPatch(syaryoMasterActions.setタイヤサイズフロント(v))}
                          />
                        </div>
                      </td>
                      <th className="min-w-8rem">軸</th>
                      <td>
                        <div className="input-group">
                          <TextInput
                            style={{ width: "20rem" }}
                            id="フロント"
                            name="フロント"
                            value={syaryoMaster.タイヤサイズ軸}
                            setValue={(v) => disPatch(syaryoMasterActions.setタイヤサイズ軸(v))}
                          />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </>
  )
}

export default TireSizeDataPane
